import {http} from '@/http'

export default {
  listAvailable() {
    return http.get('/celulares/employee/available')
  },
  listActive(position) {
    return http.get('/celulares/employee', { params: {position} })
  },
  list(data, params) {
    return http.post("/celulares/employee/list", data, { params });
  },
  save(employeeId, data) {
    return http.post(`/celulares/employee/${employeeId}`, data);
  },
  update(employeeId, data) {
    return http.put(`/celulares/employee/${employeeId}`, data);
  },
  get(employeeId) {
    return http.get(`/celulares/employee/${employeeId}`);
  },
  delete(employeeId) {
    return http.delete(`/celulares/employee/${employeeId}`);
  },
  changeStatus(employeeId, status) {
    return http.put(`/celulares/employee/${employeeId}/status`, null, {
      params: { status },
    });
  },
}
